module.exports = __webpack_public_path__ + "static/img/5-3.ec57c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/5-3.png
// module id = +/Jv
// module chunks = 1